import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { AgencyGroupEditorData } from "../../state/AgencyGroups/EditorData";


const updateAgencyGroupEditorData: Reducer<AgencyGroupEditorData> = (state: AgencyGroupEditorData = new AgencyGroupEditorData(), action: Action<ActionType, AgencyGroupEditorData>) => {
  switch (action.type) {
    case ActionType.AGENCY_GROUPS_EDITOR_DATA_RESET:
      return new AgencyGroupEditorData();
    case ActionType.AGENCY_GROUPS_EDITOR_DATA_FETCHED:
      return { ...state, agencyGroupData: action.data };
    case ActionType.AGENCY_GROUPS_EDITOR_DATA_COPIED:
      return { ...state, agencyGroupData: { ...action.data} };
    case ActionType.AGENCY_GROUPS_EDITOR_DATA_UPDATED:
      return { ...state, agencyGroupData: { ...state.agencyGroupData, ...action.data } };
    case ActionType.AGENCY_GROUPS_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.AGENCY_GROUPS_EDITOR_DATA_VALIDATED:
      return { ...state, validation: action.data };
    case ActionType.AGENCY_GROUPS_EDITOR_DATA_SET_BRAND_AND_MARKET:
      return { ...state, agencyGroupData: {brandAndMarket: action.data} };
    default:
      return state;
  }
};

export default updateAgencyGroupEditorData;
